// Ruoli realm Keycloak, come arrivano da GET /account (middlewares/auth_middleware.py:
// 'user' di default, 'legals' o 'admin' se presenti fra i realm role).
// Sono minuscoli: il confronto con "ADMIN" e' sempre falso.
export const ROLE_ADMIN = "admin";
export const ROLE_LEGALS = "legals";
export const ROLE_USER = "user";

// Solo admin: pannello utenti e log attivita'.
export const ADMIN_ROLES = [ROLE_ADMIN];

// Operatori: chi lavora le pratiche altrui (takedown, rubrica domini) e chi puo'
// aprire una sessione act-as.
export const OPERATOR_ROLES = [ROLE_ADMIN, ROLE_LEGALS];

export const isOperatorRole = (role?: string): boolean =>
  !!role && OPERATOR_ROLES.includes(role);
